export default class Games {
    static readonly TWO_HITS = "2 HITS";
    static readonly THREE_HITS = "3 HITS";
    static readonly FOUR_HITS = "4 HITS";
    static readonly FIVE_HITS = "5 HITS";
    static readonly SIX_HITS = "6 HITS";

    static toString(): string {
        return Games.TWO_HITS + ", " + Games.THREE_HITS + ", " + Games.FOUR_HITS + ", " + Games.FIVE_HITS + " and " + Games.SIX_HITS;
    }

}